<template>
  <b-card>
    <contact-edit-account
      v-if="loader === false"
      class="mt-2 pt-75"
      :user-data="userData"
      :form-data="formData"
    />
  </b-card>
</template>

<script>
import { BCard } from 'bootstrap-vue'
import { ref/* , onUnmounted */ } from '@vue/composition-api'
import store from '@/store'
import router from '@/router'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import ContactEditAccount from './ContactEditAccount.vue'
import userStoreModule from '../contactStoreModule'

export default {
  components: {
    BCard,
    ContactEditAccount,
  },
  data() {
    return {
      loader: true,
      busy: false,
      userData: ref(null),
      formData: ref(null),
    }
  },
  created() {
    // const userData = ref(null)
    const USER_APP_STORE_MODULE_NAME = 'app-contact'
    // Register module
    if (!store.hasModule(USER_APP_STORE_MODULE_NAME)) store.registerModule(USER_APP_STORE_MODULE_NAME, userStoreModule)
    store.dispatch('app-contact/fetchContact', { id: router.currentRoute.params.id })
      .then(response => {
        this.userData = response.data.data
        this.userData.address.house_number = response.data.data.address.house_no
        this.formData = { ...response.data }
        this.loader = false
      })
      .catch(error => {
        if (error.response.status === 404) {
          this.userData = undefined
        }
        if (error.response.status === 422) {
          this.$toast({
            component: ToastificationContent,
            position: 'top-right',
            props: {
              title: 'Error',
              icon: 'CoffeeIcon',
              variant: 'danger',
              text: error.response.data.message,
            },
          })
          this.$router.push('/clients/list')
        }
      })
  },
}
</script>

<style>

</style>
